import { useNavigate } from 'react-router-dom';
import { CheckCircle2, Circle, Clock } from 'lucide-react';
import type { FC } from 'react';
import type { Lesson } from '@/lib/learning/courses';

interface LessonListItemProps {
  lesson: Lesson;
  courseSlug: string;
  index: number;
  isCompleted: boolean;
}

export const LessonListItem: FC<LessonListItemProps> = ({ lesson, courseSlug, index, isCompleted }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(`/learning/${courseSlug}/${lesson.slug}`)}
      className={`group flex w-full items-center gap-4 rounded-lg border px-4 py-3 text-left transition-all duration-150 ${
        isCompleted
          ? 'border-emerald-200 dark:border-emerald-800/50 bg-emerald-50/50 dark:bg-emerald-900/10 hover:border-emerald-300 dark:hover:border-emerald-700'
          : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-blue-300 dark:hover:border-blue-600 hover:shadow-sm'
      }`}
    >
      {/* Status icon */}
      <div className="flex-shrink-0">
        {isCompleted ? (
          <CheckCircle2 className="w-5 h-5 text-emerald-500 dark:text-emerald-400" />
        ) : (
          <Circle className="w-5 h-5 text-slate-300 dark:text-slate-600 group-hover:text-blue-400" />
        )}
      </div>

      {/* Number */}
      <span className="flex-shrink-0 text-xs font-medium text-slate-400 dark:text-slate-500 tabular-nums w-5 text-center">
        {index + 1}
      </span>

      {/* Title */}
      <span className={`flex-1 text-sm font-medium ${
        isCompleted
          ? 'text-slate-600 dark:text-slate-300'
          : 'text-slate-900 dark:text-white'
      }`}>
        {lesson.title}
      </span>

      {/* Duration */}
      <div className="flex items-center gap-1 text-xs text-slate-400 dark:text-slate-500 flex-shrink-0">
        <Clock className="w-3.5 h-3.5" />
        {lesson.duration}
      </div>
    </button>
  );
};
